import { Table } from "common/Table/Table";
import { useDebounce } from "hooks/useDebounce";
import { Fragment, useCallback, useEffect, useState } from "react";
import UserService from "services/user.service";
import { exportToCSV, formatDate } from "utils/funcs";
import { DATE } from "./trainings/WeeklyStats";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import CopyText from "common/CopyText";
import { useRouter } from "hooks/useRouter";
import { tabStyles } from "./GeneralData";
import classNames from "classnames";
import { useNotifications } from "hooks/useNotification";

const service = new UserService();

export const DealerTrainings = () => {
  const { push, query } = useRouter();

  const rsvpColumns = [
    { key: "badgeId", title: "badge Id", dbColName: "badgeId" },
    { key: "companyId", title: "company Id", dbColName: "companyId" },
    { key: "firstName", title: "first Name", dbColName: "firstName" },
    { key: "lastName", title: "last Name", dbColName: "lastName" },
    { key: "phone", title: "phone", dbColName: "phone" },
    { key: "email", title: "email", dbColName: "email" },
    {
      key: "meetingStartTime",
      title: "meeting Start Time",
      dbColName: "meetingStartTime",
    },
    {
      key: "meetingEndTime",
      title: "meeting End Time",
      dbColName: "meetingEndTime",
    },
    { key: "rsvpStatus", title: "rsvp Status", dbColName: "rsvp Status" },
    {
      key: "attendeesStatus",
      title: "attendees Status",
      dbColName: "attendees Status",
    },
    {
      key: "createdAt",
      title: "createdAt",
      dbColName: "createdAt",
      render: (date) => formatDate(date),
    },
  ];

  const columns = [
    { key: "badgeId", dbColName: "badgeId", title: "badgeId" },
    {
      key: "meetingDate",
      dbColName: "meetingDate",
      title: "meetingDate",
      render: (date) => formatDate(date),
    },
    { key: "createdBy", dbColName: "createdBy", title: "created By" },
    { key: "companyId", dbColName: "companyId", title: "companyId" },
    { key: "campaignName", title: "campaign Name", dbColName: "campaignName" },

    { key: "source", dbColName: "source", title: "source" },
    { key: "connectType", dbColName: "connectType", title: "connect Type" },
    {
      key: "connectFormat",
      dbColName: "connectFormat",
      title: "connect Format",
    },
    { key: "timeZone", dbColName: "timeZone", title: "timeZone" },
    {
      key: "meetingLink",
      dbColName: "meetingLink",
      title: "meeting Link",
      render: (link) => <CopyText text={link} copyText={link} />,
    },
    {
      key: "meetingStartTime",
      dbColName: "meetingStartTime",
      title: "meeting Start Time",
    },
    {
      key: "meetingEndTime",
      dbColName: "meetingEndTime",
      title: "meeting End Time",
    },
    // {key: "calendarID", dbColName: "calendarID", title: "calendar ID"},
    {
      key: "attendedCount",
      dbColName: "attendedCount",
      title: "Total attended",
    },
    {
      key: "attendeesHireCount",
      dbColName: "attendeesHireCount",
      title: "Total Hire",
    },
    {
      key: "attendeesDenyCount",
      dbColName: "attendeesDenyCount",
      title: "Total Deny",
    },
    { key: "rsvpCount", dbColName: "rsvpCount", title: "rsvp" },
    { key: "location", dbColName: "location", title: "location" },
    { key: "address", dbColName: "address", title: "address" },
    { key: "city", dbColName: "city", title: "city" },
    { key: "state", dbColName: "state", title: "state" },
    { key: "zipCode", dbColName: "zipCode", title: "zipCode" },
    {
      key: "createdAt",
      dbColName: "createdAt",
      title: "createdAt",
      render: (date) => formatDate(date),
    },
    {
      key: "action",
      freeze: true,
      freezeIndex: "right-0",
      title: "action",
      render: (row) => {
        return (
          <div className="flex items-center justify-center gap-4">
            <p className="text-zinc-700">
             {row.connectType === "Interested Candidates" ? `${row?.screenCount ?? 0} - ${row?.screenContactedCount ?? 0}` : 
        `${row.attendedCount} - ${row.rsvpCount}`
            
            }
            </p>
            <button
              type="button"
              className="text-blue-500"
              onClick={() => push(`/dealer-details/${row._id}?connectType=${row.connectType === "Interested Candidates" ? row.connectType : ""}`)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
              </svg>
            </button>
            <button type="button" onClick={() => handleDeleteTraining(row._id)} className="text-red-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                />
              </svg>
            </button>
          </div>
        );
      },
    },
  ];

  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [rsvpData, setRsvpData] = useState([]);
  const [rsvpTotalItems, setRsvpTotalItems] = useState(0);
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 100,
    badgeId: "",
    connectType: "",
    phoneNumber: "",
    fullName: "",
    date: "YEARTODATE",
  });
  const [rsvpFilters, setRsvpFilters] = useState({
    pageNumber: 1,
    pageSize: 100,
    date: "YEARTODATE",
    rsvpStatus: "",
    attendeesStatus: "",
    email: "",
    phone: "",
    badgeId: "",
    companyId: "",
  });

  const debounced = useDebounce(pagination, 500);
  const { successMessage } = useNotifications()

  const fetchData = useCallback(() => {
    setLoading(true);
    service
      .dealersTrainings(debounced)
      .then((resp) => {
        setData(resp.data.data);
        setTotalItems(+resp.data.totalDocument);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [debounced]);

  const fetchRsvpData = useCallback(() => {
    setLoading(true);
    service
      .getDealerRSVP(rsvpFilters)
      .then((resp) => {
        setRsvpData(resp.data.data);
        setRsvpTotalItems(resp.data.totalDocument);
      })
      .catch((error) => console.log("RSVP Error", error))
      .finally(() => {
        setLoading(false);
      });
  }
  , [rsvpFilters]);

  useEffect(() => {
      fetchRsvpData();
  }, [fetchRsvpData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleExport = () => {
    setExporting(true);
    service
      .dealersTrainings({
        ...pagination,
        pageNumber: "",
        pageSize: "",
        isDownload: "true",
      })
      .then((resp) => {
        exportToCSV(resp.data.data, "trainings");
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setExporting(false);
      });
  }

  const handleDeleteTraining = (id: string) => {
    swal({
      title: "Are you sure, you want to delete this training?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        service
          .deleteDealerTraining(id)
          .then((resp) => {
            if (resp.data.success) {
              successMessage("Training deleted successfully");
              const index = data.findIndex(
                (item: { _id: string }) => item._id === id
              );
              const shallowCopy = [...data];
              shallowCopy.splice(index, 1);
              setData(shallowCopy);
            }
          })
          .catch((error) => console.log(error));
      }
    });
  }

  const clearFilter = () => {
    setPagination({
      pageNumber: 1,
      phoneNumber: "",
      connectType: "",
      pageSize: 500,
      badgeId: "",
      fullName: "",
      date: "YEARTODATE",
    });
  };

  const clearRsvpFilter = () => {
    setRsvpFilters({
      pageNumber: 1,
      pageSize: 100,
      date: "YEARTODATE",
      rsvpStatus: "",
      attendeesStatus: "",
      email: "",
      phone: "",
      badgeId: "",
      companyId: "",
    });
  };

  return (
    <Fragment>
      <div className="flex flex-col mb-4">
        <h1 className="page-title">
          Dealer Trainings
        </h1>
        <p className="page-subtitle">View all</p>
      </div>
      <div className="tabs mb-4">
        <div className="flex flex-wrap gap-1">
          <button
            type="button"
            onClick={() => push("/dealer-trainings")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: !query.tab,
            })}
          >
            Trainings
          </button>

          <button
            type="button"
            onClick={() => push("/dealer-trainings?tab=Rsvp")}
            className={classNames(tabStyles.default, {
              [tabStyles.active]: query.tab === "Rsvp",
            })}
          >
            Attendees & RSVP
          </button>
        </div>
      </div>
      {!query.tab ? (
        <Table
          data={data}
          handleExport={handleExport}
          pagination={pagination}
          setData={setData}
          exporting={exporting}
          setPagination={setPagination}
          showSearch={false}
          loadingData={loading}
          filters={
            <Filters
              clearFilter={clearFilter}
              pagination={pagination}
              setPagination={setPagination}
            />
          }
          totalItems={totalItems}
          columns={columns}
        />
      ) : (
        <Table
          columns={rsvpColumns}
          columnFilters={
            <RsvpColumnFilters
              clearFilter={clearRsvpFilter}
              pagination={rsvpFilters}
              setPagination={setRsvpFilters}
            />
          }
          showSearch={false}
          data={rsvpData}
          filters={
            <RsvpFilters
              clearFilter={clearRsvpFilter}
              pagination={rsvpFilters}
              setPagination={setRsvpFilters}
            />
          }
          setPagination={setRsvpFilters}
          pagination={rsvpFilters}
          totalItems={rsvpTotalItems}
        />
      )}
    </Fragment>
  );
};

export const Filters = ({ clearFilter, pagination, setPagination }: any) => {
  const filters = { ...pagination };
  delete filters.pageNumber;
  delete filters.pageSize;
  const hasFilters = Object.values(filters).some((item) => item);

  const [showCustom, setShowCustom] = useState(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  const handleChangeDates = (dates) => {
    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    if ((!start && !end) || end) {
      setPagination({
        ...pagination,
        date: `${moment(start).format("YYYY-MM-DD")},${moment(end).format(
          "YYYY-MM-DD"
        )}`,
      })
    }
  }

  return (
    <div className="flex items-center flex-1 gap-2">
      <input
        className="flex-1 px-3 py-2 text-sm"
        type="text"
        value={pagination.badgeId}
        placeholder="Badge ID"
        onChange={(e) => {
          setPagination({
            ...pagination,
            badgeId: e.target.value,
          });
        }}
      />
      <input
        className="w-full px-3 py-2 text-sm"
        type="text"
        value={pagination.fullName}
        placeholder="Search by Name"
        onChange={(e) => {
          setPagination({
            ...pagination,
            fullName: e.target.value,
          });
        }}
      />
      <input
        placeholder="Phone number"
        className="flex-1 px-3 py-2 text-sm"
        type="text"
        value={pagination.phoneNumber}
        onChange={(e) => {
          setPagination({
            ...pagination,
            phoneNumber: e.target.value,
          });
        }}
      />
      <select
        className="px-4 py-2 text-sm font-light text-gray-800 border-gray-200 rounded-md focus:border-gray-300 focus:outline-none focus:ring-0"
        value={pagination.connectType}
        onChange={(e) => {
          setPagination({
            ...pagination,
            connectType: e.target.value,
          });
        }}
      >
        <option value="">Connect Type</option>
        <option value="Interview Series">Interview Series</option>
        <option value="Interested Candidates">Interested Candidates</option>
      </select>

      <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        {/* <label className="field-label">Signed Rep Date</label> */}
        <select
          value={pagination.date}
          className="px-4 py-2 text-sm font-light text-gray-800 border-gray-200 rounded-md focus:border-gray-300 focus:outline-none focus:ring-0"
          onChange={(e) => {
            if (e.target.value !== "CUSTOM") {
              setPagination({ ...pagination, date: e.target.value });
            } else {
              setShowCustom(true);
            }
          }}
        >
          <option>Select</option>
          {DATE.map((item) => (
            <option value={item} key={item}>
              {item}
            </option>
          ))}
        </select>
        {showCustom && (
          <DatePicker
            selected={startDate}
            placeholderText="Select range"
            onChange={handleChangeDates}
            startDate={startDate}
            endDate={endDate}
            isClearable
            className="py-2 ml-2 z-100 w-60"
            customInput={
              <input
                placeholder="Select date"
                className="w-60 px-3 py-2 text-sm"
              />
            }
            selectsRange
            selectsDisabledDaysInRange
          />
        )}
      </div>

      {hasFilters && (
        <button
          onClick={() => {
            clearFilter();
          }}
          className="btn-dark whitespace-nowrap"
        >
          Clear Filters
        </button>
      )}
    </div>
  );
};

const RsvpFilters = ({ clearFilter, pagination, setPagination }: any) => {
  const filters = { ...pagination };
  delete filters.pageNumber;
  delete filters.pageSize;
  const hasFilters = Object.values(filters).some((item) => item);

  return (
    <div className="flex items-center flex-1 gap-4">
      <input
        className="w-full px-3 py-2 text-sm"
        type="text"
        value={pagination.email}
        placeholder="Search by Email"
        onChange={(e) => {
          setPagination({
            ...pagination,
            email: e.target.value,
          });
        }}
      />
      <input
        className="flex-1 px-3 py-2 text-sm"
        type="text"
        value={pagination.badgeId}
        placeholder="Badge ID"
        onChange={(e) => {
          setPagination({
            ...pagination,
            badgeId: e.target.value,
          });
        }}
      />
      <input
        className="w-full px-3 py-2 text-sm"
        type="text"
        value={pagination.companyId}
        placeholder="Search by Company ID"
        onChange={(e) => {
          setPagination({
            ...pagination,
            companyId: e.target.value,
          });
        }}
      />
      <input
        placeholder="Phone number"
        className="flex-1 px-3 py-2 text-sm"
        type="text"
        value={pagination.phone}
        onChange={(e) => {
          setPagination({
            ...pagination,
            phone: e.target.value,
          });
        }}
      />

      {hasFilters && (
        <button
          onClick={() => {
            clearFilter();
          }}
          className="btn-dark whitespace-nowrap"
        >
          Clear Filters
        </button>
      )}
    </div>
  );
};

const RsvpColumnFilters = ({ clearFilter, pagination, setPagination }: any) => {
  const [showCustom, setShowCustom] = useState(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  const handleChangeDates = (dates) => {
    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    if ((!start && !end) || end) {
      setPagination({
        ...pagination,
        date: `${moment(start).format("YYYY-MM-DD")},${moment(end).format(
          "YYYY-MM-DD"
        )}`,
      });
    }
  };

  return (
    <div>
      <div className="flex flex-1 gap-4 mt-3">
        <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
          <label className="field-label">RSVP Status</label>
          <select
            value={pagination.rsvpStatus}
            className="w-full px-3 py-2 text-sm"
            onChange={(e) => {
              setPagination({ ...pagination, rsvpStatus: e.target.value });
            }}
          >
            <option>Select</option>
            <option value="Scheduled">Scheduled</option>
            <option value="Not-Attended">Not-Attended</option>
            <option value="Attended">Attended</option>
          </select>
        </div>
        <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
          <label className="field-label">Attendees Status</label>
          <select
            value={pagination.attendeesStatus}
            className="w-full px-3 py-2 text-sm"
            onChange={(e) => {
              setPagination({ ...pagination, attendeesStatus: e.target.value });
            }}
          >
            <option>Select</option>
            <option value="Scheduled">Hire</option>
            <option value="Not-Attended">Deny</option>
          </select>
        </div>
        <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
          <label className="field-label">Date</label>
          <select
            value={pagination.date}
            className="w-full px-3 py-2 text-sm"
            onChange={(e) => {
              if (e.target.value !== "CUSTOM") {
                setPagination({ ...pagination, date: e.target.value });
              } else {
                setShowCustom(true);
              }
            }}
          >
            <option>Select</option>
            {DATE.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </select>
          {showCustom && (
            <DatePicker
              selected={startDate}
              placeholderText="Select range"
              onChange={handleChangeDates}
              startDate={startDate}
              endDate={endDate}
              isClearable
              className="py-2 ml-2 z-100 w-60"
              customInput={
                <input
                  placeholder="Select date"
                  className="w-60 px-3 py-2 text-sm"
                />
              }
              selectsRange
              selectsDisabledDaysInRange
            />
          )}
        </div>
      </div>
    </div>
  );
};
